import { Text } from '@dixa/lib-shared-habla';
import { conversationLanguages } from 'lib-shared-languages';

import { useConversationRow } from '../../../utils/useConversationRow';

export const ConversationsTableLanguage = (): JSX.Element | null => {
  const { conversation } = useConversationRow();
  const language = conversation.language;

  if (!language) {
    return (
      <Text.Paragraph variant="2" color="tertiary">
        n.a.
      </Text.Paragraph>
    );
  }

  const languageEntry = conversationLanguages.find((l) => l.code === language);

  return <Text.Paragraph>{languageEntry?.name ?? language}</Text.Paragraph>;
};
